
import { initializeApp } from "firebase/app"
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyDrHBmzVAC7c1zFijM7WaibFob0ohnqtyU",
    authDomain: "pretzu-78052.firebaseapp.com",
    projectId: "pretzu-78052",
    storageBucket: "pretzu-78052.appspot.com",
    messagingSenderId: "119549448793",
    appId: "1:119549448793:web:3c920ab6054311df4e9748"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const storage = getStorage(app)

export async function uploadFile(file, path) {
    const storageRef = ref(storage, path)
    await uploadBytes(storageRef, file)
    const url = await getDownloadURL(storageRef)
    return url
}